import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const SectionWrapper = ({
    children,
    id,
    className = '',
    containerClassName = '',
    animate = true,
    delay = 0,
}) => {
    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });

    const sectionStyles = 'py-16 md:py-24 lg:py-32';
    const containerStyles = 'max-w-6xl mx-auto px-4 sm:px-6 lg:px-8';

    const variants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                delay: delay,
                ease: [0.25, 0.46, 0.45, 0.94],
            },
        },
    };

    return (
        <section
            id={id}
            ref={ref}
            className={twMerge(clsx(sectionStyles, className))}
        >
            {animate ? (
                <motion.div
                    className={twMerge(clsx(containerStyles, containerClassName))}
                    initial="hidden"
                    animate={inView ? 'visible' : 'hidden'}
                    variants={variants}
                >
                    {children}
                </motion.div>
            ) : (
                <div className={twMerge(clsx(containerStyles, containerClassName))}>
                    {children}
                </div>
            )}
        </section>
    );
};

export default SectionWrapper;
